import { Box, Typography } from "@mui/material";
import React from "react";
import checklistpink from "../../../../../../../../media/images/icons/checklistpink.png";
import ArrowLeftSVG from "../../../../../../../../media/images/icons/arrow-left";
import { Link } from "react-router-dom";

export default function SubLinks() {
  return (
    <>
      <Box
        sx={{
          mt: 2,
          display: "flex",
          alignItems: "center",
          gap: "8px",
        }}
      >
        <Box
          sx={{
            flex: "1",
            borderRadius: "16px",
            display: "flex",
            justifyContent: "end",
            backgroundColor: "primary.main",
            backgroundImage: `url(${checklistpink})`,
            backgroundRepeat: "no-repeat",
            backgroundPosition: "100% 50%",
            backgroundSize: "70px",
            padding: "16px 8px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              // border: "1px solid gray",
              flexDirection: "column",
              gap: "4px",
              width: "65%",
            }}
          >
            <Link
              to={"#"}
              style={{
                display: "flex",
                justifyContent: "end",
                alignItems: "center",
                gap: "8px",
                //   border: "1px solid gray",
              }}
            >
              <Typography
                noWrap
                sx={{
                  fontSize: "18px",
                  color: "#fff",
                  fontWeight: "600",
                }}
              >
                ماموریت ها
              </Typography>
              <ArrowLeftSVG color="#fff" />
            </Link>
            <Typography
              sx={{
                color: "#fff",
                fontSize: "12px",
              }}
            >
              درخواست‌های افزایش قیمت و مناقصات بار
            </Typography>
          </Box>
        </Box>
        <Box
          sx={{
            flex: "1",
            borderRadius: "16px",
            display: "flex",
            justifyContent: "end",
            backgroundColor: "primary.main",
            backgroundImage: `url(${checklistpink})`,
            backgroundRepeat: "no-repeat",
            backgroundPosition: "100% 50%",
            backgroundSize: "70px",
            padding: "16px 8px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              // border: "1px solid gray",
              flexDirection: "column",
              gap: "4px",
              width: "65%",
            }}
          >
            <Link
              to={"#"}
              style={{
                display: "flex",
                justifyContent: "end",
                alignItems: "center",
                gap: "8px",
                //   border: "1px solid gray",
              }}
            >
              <Typography
                sx={{
                  fontSize: "18px",
                  color: "#fff",
                  fontWeight: "600",
                }}
              >
                جوایز{" "}
              </Typography>
              <ArrowLeftSVG color="#fff" />
            </Link>
            <Typography
              sx={{
                color: "#fff",
                fontSize: "12px",
              }}
            >
              درخواست‌های افزایش قیمت و مناقصات بار
            </Typography>
          </Box>
        </Box>
      </Box>
      <Box
        sx={{
          mt: 2,
          flex: "1",
          borderRadius: "16px",
          display: "flex",
          justifyContent: "end",
          backgroundColor: "primary.main",
          backgroundImage: `url(${checklistpink})`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "90% 50%",
          backgroundSize: "70px",
          padding: "16px 8px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            // border: "1px solid gray",
            flexDirection: "column",
            gap: "4px",
            width: "50%",
          }}
        >
          <Link
            to={"#"}
            style={{
              display: "flex",
              justifyContent: "end",
              alignItems: "center",
              gap: "8px",
              //   border: "1px solid gray",
            }}
          >
            <Typography
              noWrap
              sx={{
                fontSize: "18px",
                color: "#fff",
                fontWeight: "600",
              }}
            >
              دعوت از دوستان{" "}
            </Typography>
            <ArrowLeftSVG color="#fff" />
          </Link>
          <Typography
            sx={{
              color: "#fff",
              fontSize: "12px",
            }}
          >
            درخواست‌های افزایش قیمت و مناقصات بار
          </Typography>
        </Box>
      </Box>
    </>
  );
}
